<template>
	<div class="centraliza-conteudo" :style="`min-height: calc(100vh - ${ajuste_altura}px)`">
		<slot />
	</div>
</template>

<script>
export default {
  name: 'CentralizaConteudo',
  props: {
    ajuste_altura: {
      type: String,
      default: '256'
    }
  }
};
</script>

<style lang="scss" scoped>
.centraliza-conteudo {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>
